export default __webpack_public_path__ + "splash-07.73f5c.svg";